import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import { ResolverQueryClientContext, useResolverQueryClient } from './useResolverQueryClient';

const STALE_TIME = 15 * 60 * 1000;
const GC_TIME = 60 * 60 * 1000;

// Per-id react-query hook backed by a DataLoader. All consumers calling
// useIdResolver({ ns, id, loader }) in the same tick coalesce into one
// batched request; the result is cached by [ns, id] for cross-feature reuse.
export const useIdResolver = ({ ns, id, loader, enabled = true, select, staleTime = STALE_TIME, gcTime = GC_TIME }) =>
  useQuery({
    queryKey: [ns, id],
    queryFn: () => loader.load(id),
    enabled: enabled && !!id,
    staleTime,
    gcTime,
    select,
    context: ResolverQueryClientContext
  });

export const useIdResolverPrefetch = ({ ns, loader }) => {
  const queryClient = useResolverQueryClient();
  return useCallback(
    ids => {
      const unique = Array.from(new Set(ids.filter(Boolean)));
      return Promise.all(
        unique.map(id =>
          queryClient.prefetchQuery({
            queryKey: [ns, id],
            queryFn: () => loader.load(id),
            staleTime: STALE_TIME
          })
        )
      );
    },
    [queryClient, ns, loader]
  );
};
